import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import $ from 'jquery'

// Make jQuery available globally
window.$ = window.jQuery = $

// Import main CSS
import './assets/css/main.css'
import './assets/css/global_copy.css'
import './assets/css/style.css'
import './assets/css/owl.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Import Owl Carousel CSS only (we'll use custom slider instead)
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel/dist/assets/owl.theme.default.css'

// Ensure particles.js is available globally
window.addEventListener('load', () => {
  console.log('Window loaded, particles.js available:', !!window.particlesJS);
});

const app = createApp(App)
app.use(router)
app.mount('#app') 